import classes from './Hr.module.css';

const Hr = () => {
    return <hr className={classes.hr} />
}

export default Hr;